import { tns } from 'tiny-slider';

export function introSlider() {
    let slider = document.getElementById('intro-slider');
    if (slider) {
        slider = tns({
            container: '#intro-slider',
            items: 1,
            gutter: 0,
            //autoplay: true,
            autoplayButton: false,
            autoplayButtonOutput: '',
            speed: 800,
            nav: true,
            navPosition: 'bottom',
            mouseDrag: true,
            touch: true,
            controls: false,
            controlsPosition: 'bottom',
            controlsText: ['<span class="icon-basic icon-chevron-left-circled"></span>', '<span class="icon-basic icon-chevron-right-circled"></span>']
        });

    }

    return 'introSlider';

}

export function reviewSlider() {
    let slider = document.getElementById('reviews-slider');
    if (slider) {
        slider = tns({
            container: '#reviews-slider',
            items: 1.125,
            gutter: 32,
            autoplay: false,
            nav: true,
            navPosition: 'bottom',
            mouseDrag: true,
            touch: true,
            controls: false,
            controlsPosition: 'bottom',
            controlsText: ['<span class="icon-basic icon-chevron-left-circled"></span>', '<span class="icon-basic icon-chevron-right-circled"></span>'],
            responsive: {
                576: {
                    items: 1.5
                },
                768: {
                    items: 2,
                },
                1024: {
                    items: 3
                }
            }
        });

    }

    return 'reviewSlider';

}
